import {
  MANAGE_ORDER_RETURN_LOADING,
  MANAGE_ORDER_RETURN_ERROR,
  MANAGE_ORDER_RETURN_SUCCESS,
} from "./type";

const initState = {
  loading: true,
  error: false,
  orderReturnReasons: [],
};
const orderReturnReducer = (state = initState, action) => {
  switch (action.type) {
    case MANAGE_ORDER_RETURN_LOADING:
      return { ...state, loading: true };
    case MANAGE_ORDER_RETURN_ERROR:
      return { ...state, loading: false, error: true };
    case MANAGE_ORDER_RETURN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        orderReturnReasons: action.payload.reasons,
        totalCount: action.payload.totalRecords,
      };
    default:
      return state;
  }
};

export { orderReturnReducer };
